import React from "react";
import { FormControlLabel, Grid, Radio, RadioGroup } from "@material-ui/core";
import { clsx } from "clsx";
import { workoutStyles } from "../../pages/workout/workout.styles";
import { WorkoutDetails } from "../../../models/gameplan";

interface Answer {
  option: string;
  text: string;
}

interface WorkoutAnswerProps {
  participantProfileId: string;
  answers: Answer[];
  answerSelected: string;
  onChecked: (value: string) => void;
  isDisabled: boolean;
  workoutDetails: WorkoutDetails;
}
export const WorkoutAnswer = ({
  answerSelected,
  answers,
  onChecked,
  isDisabled,
}: WorkoutAnswerProps) => {
  const classes = workoutStyles();

  const onClick = (event) => {
    const { value } = event.target;
    onChecked(value);
  };

  return (
    <Grid item xs={12} className={classes.answerContainer}>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name="workout-answer"
        value={answerSelected || false}
      >
        {answers?.map((answer: Answer) => (
          <Grid item xs={12} key={answer.option}>
            <FormControlLabel
              value={answer.option}
              disabled={isDisabled}
              className={clsx({ [classes.desabledOption]: isDisabled })}
              control={
                <Radio
                  disabled={isDisabled}
                  color="default"
                  checked={answer.option === answerSelected}
                  value={answer.option}
                  onClick={onClick}
                />
              }
              label={
                <>
                  <b>{answer.option}.</b> {answer.text}
                </>
              }
            />
          </Grid>
        ))}
      </RadioGroup>
    </Grid>
  );
};
